import { Row, Col, Card } from "antd";
import {
  ClockCircleOutlined,
  CarOutlined,
  CloseCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import "./styles/OrderSummaryCards.scss";
import { ORDER_STATUS_ENUM } from "../../../../applications/constants/AppConst";
import { useState } from "react";
import { UserStatisticSummary } from "../../../../infrastructure/model/AppUserModel";

interface OrderSummary {
  total: number;
  pending: number;
  delivered: number;
  cancelled: number;
  refunded: number;
}
const SUMMARY_STATUS_STYLE = {
  total: {
    bg: "#f0f5ff",
    color: "#1d39c4",
  },
  pending: {
    bg: "#fff7e6",
    color: "#d46b08",
  },
  delivered: {
    bg: "#f6ffed",
    color: "#389e0d",
  },
  cancelled: {
    bg: "#fff1f0",
    color: "#cf1322",
  },
  refunded: {
    bg: "#f9f0ff",
    color: "#722ed1",
  },
};

interface SummaryCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  status: keyof typeof SUMMARY_STATUS_STYLE;
  active: boolean;
  onClick?: () => void;
}
const SummaryCard = (props: SummaryCardProps) => {
  const { title, value, icon, status, active = false, onClick } = props;
  const style = SUMMARY_STATUS_STYLE[status];
  return (
    <Card
      className={`summary-card ${active ? "active" : ""}`}
      style={{ background: style.bg }}
      onClick={onClick}
    >
      <div className="summary-content">
        <div className="summary-icon" style={{ color: style.color }}>
          {icon}
        </div>

        <div>
          <div className="summary-value" style={{ color: style.color }}>
            {value}
          </div>
          <div className="summary-title">{title}</div>
        </div>
      </div>
    </Card>
  );
};

interface OrderSummaryCardsProps {
  summary?: UserStatisticSummary;
}
function OrderSummaryCards(props: OrderSummaryCardsProps) {
  const { summary } = props;
  const [selectedStatus, setSelectedStatus] = useState<ORDER_STATUS_ENUM>();
  return (
    <Row gutter={[12, 12]}>
      <Col xs={12} md={8} lg={5}>
        <SummaryCard
          title="Chờ xác nhận"
          value={summary?.total_pending ?? 0}
          icon={<ClockCircleOutlined />}
          status="pending"
          active={selectedStatus === ORDER_STATUS_ENUM.NOT_CONFIRM}
          onClick={() => setSelectedStatus(ORDER_STATUS_ENUM.NOT_CONFIRM)}
        />
      </Col>
      <Col xs={12} md={8} lg={5}>
        <SummaryCard
          title="Đang pha chế"
          value={summary?.total_processing ?? 0}
          icon={<ClockCircleOutlined />}
          status="pending"
          active={selectedStatus === ORDER_STATUS_ENUM.APPROVE}
          onClick={() => setSelectedStatus(ORDER_STATUS_ENUM.APPROVE)}
        />
      </Col>
      <Col xs={12} md={8} lg={5}>
        <SummaryCard
          title="Đã giao"
          value={summary?.total_complete ?? 0}
          icon={<CarOutlined />}
          status="delivered"
          active={selectedStatus === ORDER_STATUS_ENUM.COMPLETE}
          onClick={() => setSelectedStatus(ORDER_STATUS_ENUM.COMPLETE)}
        />
      </Col>

      <Col xs={12} md={8} lg={5}>
        <SummaryCard
          title="Đã hủy"
          value={summary?.total_reject ?? 0}
          icon={<CloseCircleOutlined />}
          status="cancelled"
          active={selectedStatus === ORDER_STATUS_ENUM.REJECT}
          onClick={() => setSelectedStatus(ORDER_STATUS_ENUM.REJECT)}
        />
      </Col>

      <Col xs={12} md={8} lg={4}>
        <SummaryCard
          title="Hoàn"
          value={summary?.total_return ?? 0}
          icon={<ReloadOutlined />}
          status="refunded"
          active={selectedStatus === ORDER_STATUS_ENUM.RETURN}
          onClick={() => setSelectedStatus(ORDER_STATUS_ENUM.RETURN)}
        />
      </Col>
    </Row>
  );
}
export default OrderSummaryCards;
